module.exports = __webpack_public_path__ + "img/s4_img.10da849f.png";